import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whistle-icon',
  templateUrl: './whistle-icon.component.html',
  styleUrls: ['./whistle-icon.component.scss']
})
export class WhistleIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
